import { observer } from 'mobx-react';
import { ICON_BUTTON_ICONS } from '../../../components/buttons/IconButton';
import useHistory from '../../../hooks/useHistory';
import { paths } from '../../../utils/constants/routes';
import { encodeOutreachParams } from './constants';
import { useStore } from '../../../store/store';

const icons = {
  funds: ICON_BUTTON_ICONS.CASH_STACK,
  portfolios: ICON_BUTTON_ICONS.PORTFOLIO_COMPANY,
  investprofiles: ICON_BUTTON_ICONS.INVEST_PROFILE
};

const InvestorObjectButton = observer(
  ({ objectId = '', object = {}, params = {}, list = {}, type = '' }) => {
    const { outreachStore } = useStore();
    const { navigate } = useHistory();
    const isSelected = params.selected === objectId && !!list[objectId] && params.type === type;

    const onSelect = () => {
      if (isSelected) {
        return;
      }

      const firstOutreach = list[objectId].outreaches
        .slice()
        .sort(
          (a, b) =>
            (outreachStore.messages[b.id][outreachStore.messages[b.id].length - 1]?.date || 0) -
            (outreachStore.messages[a.id][outreachStore.messages[a.id].length - 1]?.date || 0)
        )[0];

      navigate(
        paths.OUTREACH +
          '?params=' +
          encodeOutreachParams({ selected: objectId, type, outreachId: firstOutreach?.id || null })
      );
    };

    return (
      <div
        className={`noselect agent-project-button${isSelected ? ' selected' : ''}`}
        onClick={onSelect}>
        <img className="icon-title" src={icons[object.objectType]} />
        <div className="head-title">{object.name}</div>
        {object.newMessagesCount > 0 && <div className="head-count">{object.newMessagesCount}</div>}
        {!object.newMessagesCount && object.hasMarkedUnread && <div className="head-count" />}
      </div>
    );
  }
);

export default InvestorObjectButton;
